module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Rotalic.a775af84.woff2";